import { render, staticRenderFns } from "./match.vue?vue&type=template&id=a98158ae&"
import script from "./match.vue?vue&type=script&lang=js&"
export * from "./match.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a98158ae')) {
      api.createRecord('a98158ae', component.options)
    } else {
      api.reload('a98158ae', component.options)
    }
    module.hot.accept("./match.vue?vue&type=template&id=a98158ae&", function () {
      api.rerender('a98158ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/pages/dataImport/components/match.vue"
export default component.exports